import { createContext } from 'react';

import { OidcClient } from '@britishcouncil/react-oidc-auth';

export type AppSettings = {
  status: 'loading' | 'loaded' | 'error';
  userManager: OidcClient.UserManagerSettings;
  sharedApiUrl: string;
  newApiUrl: string;
  sentryConfig: {
    enabled: boolean;
    dsn: string;
    release: string;
    env: string;
  };
  prsFeatureEnabled: boolean;
};

export const DEFAULT_APP_SETTINGS: AppSettings = {
  status: 'loading',
  sharedApiUrl: 'https://host.docker.internal:54401/api/',
  newApiUrl: 'https://host.docker.internal:55503/api/',
  sentryConfig: {
    enabled: false,
    dsn: '',
    release: '',
    env: '',
  },
  userManager: {
    authority: 'https://host.docker.internal:5000',
    client_id: 'schools-b2c',
    redirect_uri: 'https://host.docker.internal:55780/login-redirect',
    response_type: 'code',
    scope: 'srs.b2c srs.api openid email offline_access',
    post_logout_redirect_uri: 'https://host.docker.internal:55780/logout-redirect',
    automaticSilentRenew: true,
  },
  prsFeatureEnabled: true,
};

export const AppSettingsContext = createContext<AppSettings>(DEFAULT_APP_SETTINGS);
